export default __webpack_public_path__ + "static/media/4745@2x.767a4208.webp";